const checkoutServiceMixin = {
    data: function () {
        return {
            CHECKOUT_BASE: '/Api/Checkout/'
        }
    },
    methods: {
        setDeliveryMethodApi: function (data) {
            return this.post(this.CHECKOUT_BASE, 'SetDeliveryMethod', data);
        },
        submitPayment: function (data) {
            return this.post(this.CHECKOUT_BASE, 'SubmitPayment', data);
        },
        submitMotoPayment: function (data) {
            return this.post(this.CHECKOUT_BASE, 'SubmitMotoPayment', data);
        },
        isOrderNumberCreated: function (data) {
            return this.get(this.CHECKOUT_BASE, 'IsOrderNumberCreated', data);
        },
        getBasketReviewItems: function () {
            return this.get(this.CHECKOUT_BASE, 'BasketReviewItems');
        },
        getCheckoutAddressApi: function (data) {
            return this.get(this.CHECKOUT_BASE, 'CheckoutAddress', data);
        },
        addBillingInformation: function (data) {
            return this.post(this.CHECKOUT_BASE, 'AddBillingInformation', data);
        },
        addShippingInformation: function (data) {
            return this.post(this.CHECKOUT_BASE, 'AddShippingInformation', data);
        }
    }
}
